const getDefaultState = () => {
    return {
        dialogToEmail: {
            show: false
        },
        chatCode: {
            show: false
        },
        rightCode: {
            value: true,
            textError: ''
        },
        sendFirstMessageClient: false,
        sendFirstMessageOperator: false,
        notification: {
            show: false,
            title: '',
            error: false,
            delay: 1500
        },

        rating: {
            dateAutoClose: null,
            showSettings: {
                chat: {
                    enable: false,
                    noClickHide: true
                },
                call: {
                    enable: false
                },
                smiles: false
            },
            show: {
                view: '',
                smiles: false,
                link_id: ''
            },
            showAfterDialogChatSmiles: false
        },
        personal: {
            show: false,
            view: false,
            showSettings: {
                online: {
                    showStartChatActive: {
                        show: false,
                        noClickHide: true
                    },
                    showAfterMessage: {
                        show: false,

                        noClickHide: true
                    },
                    show: false
                },
                offline: {
                    show: false,
                    noClickHide: true
                },
                beforeCall: {
                    show: false,
                    noClickHide: true
                }
            },
            guestInfoNoSend: {}, //Если ввел но не отправил
            guestInfo: {},
            rules: {}
        },
        phoneBell: {
            show: false
        }
    }
}
// initial state
const state = getDefaultState()

export default {
    namespaced: true,
    state,
    mutations: {
        resetState(state) {
            Object.assign(state, getDefaultState())
        },
        setShowPhoneBell(state, boolean) {
            state.phoneBell.show = boolean
        },
        setShowAfterDialogChatSmiles(state, boolean) {
            state.rating.showAfterDialogChatSmiles = boolean
        },
        setRatingShow(state, { view, smiles, link_id }) {
            state.rating.show.view = view
            state.rating.show.smiles = smiles
            state.rating.show.link_id = link_id
        },
        setRatingDateAutoClose(state, { dateClose }) {
            state.rating.dateAutoClose = dateClose
        },
        setRatingChatNoClickHide(state, boolean) {
            state.rating.showSettings.chat.noClickHide = boolean
        },

        setDialogToEmailShow(state, boolean) {
            state.dialogToEmail.show = boolean
        },
        setChatCodeShow(state, boolean) {
            state.chatCode.show = boolean
        },
        setNotificationShow(state, boolean) {
            state.notification.show = boolean
        },
        setNotificationErr(state, boolean) {
            state.notification.error = boolean
        },

        setGuestInfo(state, { name, phone, email }) {
            Object.assign(state.personal.guestInfo, { name, phone, email })
        },
        setGuestInfoNoSend(state, val) {
            //state.personal.guestInfoNoSend = val
            //console.log('setGuestInfoNoSend',state.personal.guestInfoNoSend,val,Object.assign(state.personal.guestInfoNoSend,val));
            state.personal.guestInfoNoSend = Object.assign({}, state.personal.guestInfoNoSend, val)
            //state.personal.guestInfoNoSend = val
        },

        setApi(state, api) {
            state.rating.showSettings.chat.enable = Boolean(api.options.manager_rating_enable.chat)
            state.rating.showSettings.call.enable = Boolean(api.options.manager_rating_enable.call)
            state.rating.showSettings.smiles = Boolean(api.options.manager_rating_enable.smiles)

            state.personal.showSettings.beforeCall.show = Boolean(
                api.options.call_settings.guest_contacts_request
            )
            state.personal.showSettings.offline.show = Boolean(
                api.options.offline_mode.contacts_requests
            )
            state.personal.showSettings.online.show =
                api.options.guest_contacts_request.moment != '3' // Никогда
            state.personal.showSettings.online.showStartChatActive.show =
                api.options.guest_contacts_request.moment == '2' //Перед началом дивлога
            state.personal.showSettings.online.showAfterMessage.show =
                api.options.guest_contacts_request.moment == '1' // Во время диалога

            state.personal.guestInfo = api.guest_info
            //Object.assign(state.personal.guestInfoNoSend, api.guest_info)

            state.personal.rules = api.options.guest_contacts_request
        },

        setPersonalShow(state, boolean) {
            state.personal.show = boolean
        },
        setPersonalView(state, val) {
            state.personal.view = val
        },
        setSendFirstMessageClient(state) {
            state.sendFirstMessageClient = true
        },
        setSendFirstMessageOperator(state) {
            state.sendFirstMessageOperator = true
        },
        setNoClickHideShowAfterMessage(state, boolean) {
            state.personal.showSettings.online.showAfterMessage.noClickHide = boolean
            state.personal.view = false
        },
        setNoClickHideShowStartChatActive(state, boolean) {
            state.personal.showSettings.online.showStartChatActive.noClickHide = boolean
            state.personal.view = false
        },
        setNoClickHideBeforeCall(state, boolean) {
            state.personal.showSettings.beforeCall.noClickHide = boolean
            state.personal.view = false
        },
        setNoClickHideOffline(state, boolean) {
            state.personal.showSettings.offline.noClickHide = boolean
        },
        setNotificationTitle(state, string) {
            state.notification.title = string
        }
    },
    actions: {
        saveGuestInfoApi({ rootState, state, commit, dispatch }, { name, phone, email }) {
            commit('setGuestInfo', { name, phone, email })
            Object.assign(rootState.api.guest_info, { name, phone, email })
        }
    },
    getters: {
        rightCode(state) {
            return state.rightCode
        },
        showDialogFind(state) {
            return (
                state.chatCode.show ||
                state.notification.show ||
                state.dialogToEmail.show ||
                state.rating.show.view ||
                state.rating.showAfterDialogChatSmiles ||
                state.personal.show
            )
            //Todo Проверить, если оператор запросил данные,
        },

        ratingFormShowAfterDialogChatSmiles(state, getters, rootState, rootGetters) {
            return state.rating.showSettings.smiles
        },
        ratingFormChatShow(state, getters, rootState, rootGetters) {
            return (
                !state.rating.showSettings.smiles &&
                state.rating.showSettings.chat.enable &&
                state.sendFirstMessageOperator &&
                state.rating.showSettings.chat.noClickHide &&
                rootGetters.operator.online
            )
        },
        personalFormView(state, getters) {
            if (state.personal.view) return state.personal.view
            if (getters.personalFormShowOnlineStartChatActive) return 'showStartChatActive'
            if (getters.personalFormShowOnlineAfterMessage) return 'showAfterMessage'
            if (getters.personalFormShowOffline) return 'offline'
            if (getters.personalFormShowBeforeCall) return 'beforeCall'
            return false
        },
        personalFormShow(state, getters) {
            return (
                getters.personalFormShowOnlineStartChatActive ||
                getters.personalFormShowOnlineAfterMessage ||
                getters.personalFormShowOffline ||
                getters.personalFormShowBeforeCall
            )
        },
        personalFormShowOnlineStartChatActive(state, getters, rootState, rootGetters) {
            return (
                rootState.chatActiveBtn === 'chat' &&
                rootGetters.operator.online &&
                state.personal.showSettings.online.showStartChatActive.show &&
                getters.personalFormIsEmptyFieldsOptional &&
                state.personal.showSettings.online.showStartChatActive.noClickHide
            )
        },
        personalFormShowOnlineAfterMessage(state, getters, rootState, rootGetters) {
            return (
                rootGetters.operator.online &&
                state.personal.showSettings.online.showAfterMessage.show &&
                state.sendFirstMessageClient &&
                getters.personalFormIsEmptyFieldsOptional &&
                state.personal.showSettings.online.showAfterMessage.noClickHide
            )
        },
        personalFormShowOffline(state, getters, rootState, rootGetters) {
            return (
                rootState.chatActiveBtn === 'chat' &&
                !rootGetters.operator.online &&
                state.personal.showSettings.offline.show &&
                getters.personalFormIsEmptyFieldsOptional &&
                state.personal.showSettings.offline.noClickHide
            )
        },
        personalFormShowBeforeCall(state, getters, rootState, rootGetters) {
            return (
                rootState.chatActiveBtn === 'call' &&
                state.personal.showSettings.beforeCall.show &&
                getters.personalFormIsEmptyFieldsOptional &&
                state.personal.showSettings.beforeCall.noClickHide
            )
        },
        personalFormIsEmptyFieldsOptional(state) {
            let obj = state.personal.rules?.fields || {}

            return Object.entries(obj)
                .filter(item => item[1] == '1')
                .some(
                    item => !state.personal.guestInfo[item[0]] //Если хоть одно поле не заполнено из списка запрашиваемых полей, показываем форму
                )
        },
        personalFormIsFieldRequired(state) {
            let obj = state.personal.rules.required || {}

            return Object.entries(obj).filter(item => item[1] == '1').length
        }
    }
}
